import * as React from 'react';
import Swal from 'sweetalert2';
import { jaxa } from '../../App';
import { columns } from './gridData';
import EmployeeInfo from './EmployeeInfo';
import CreateEmployee from './CreateEmployee';
import { CustomizedDataGrid } from '../../components';
import { RefreshRounded as RefreshIcon } from '@mui/icons-material';
import { Box, Typography, Button, Backdrop, CircularProgress, IconButton } from '@mui/material';

export default function Employees() {

    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(true);

    const [empId, setEmpId] = React.useState(null);

    const [employees, setEmployees] = React.useState([]);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const clearEmpId = () => setEmpId(null);

    const getEmpData = async() => {
        setLoading(true);
        await jaxa.get('/get-employees').then((res) => setEmployees(res.data)).catch((e) => {
            Swal.fire({ title: 'Failed to get employees' });
            console.log(`Error: ${e}`);
        });
        setLoading(false);
    };

    const reload = () => {
        getEmpData();
    };

    React.useEffect(() => {
        getEmpData();
    }, []);

    const loader = React.useMemo(() => (
        <Backdrop open>
            <CircularProgress/>
        </Backdrop>
    ), []);

    return (

        <Box sx={{ width: '100%', height: '100vh' }}>
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', mb: 2, mt: 2 }}>
                <Typography component="h2" variant="h6" sx={{ mb: 2 }}>Employees</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <IconButton onClick={reload}>
                        <RefreshIcon/>
                    </IconButton>
                    <Button variant="outlined" onClick={handleOpen} sx={{ ml: 2 }} disabled={loading}>CREATE</Button>
                </Box>
            </Box>
            <CustomizedDataGrid columns={columns} rows={employees} onClick={e => setEmpId(e)}/>
            {open ? <CreateEmployee open={open} handleClose={handleClose}/> : null}
            {empId ? <EmployeeInfo empId={empId} open={Boolean(empId)} handleClose={clearEmpId}/> : null}
            {loading ? loader : null}
        </Box>

    );

};